import { type ILinkEntity, type ILinkProduct } from '../../apis/ilink.type';
import { type RootState } from '../store';
import { amiProductId } from '../../business/amiProductId';

export const hasKnownProduct = (product: ILinkProduct | ILinkEntity) => product.id !== amiProductId;
export const isCustomProduct = (product: ILinkProduct | ILinkEntity) => product.isCustom === true;

export const hasCatalogKnownProduct = (state: RootState) => hasKnownProduct(state.catalog.search.product);
export const hasCatalogProductOrCustom = ({
  catalog: {
    search: { product },
  },
}: RootState) => hasKnownProduct(product) || isCustomProduct(product);

export const selectCatalogSearch = (state: RootState) => state.catalog.search;

export const selectProduct = (state: RootState) => state.catalog.search.product;

export const selectProductId = (state: RootState) => state.catalog.search.product.id;

export const selectProductLabel = (state: RootState) => state.catalog.search.product.label;

export const selectTraceabilityNumber = (state: RootState) => state.catalog.search.product.traceabilityNumber;

export const selectProductSheetUrlParams = (state: RootState) => state.catalog.productSheetUrlParams;
